module.exports = __webpack_public_path__ + "static/media/imagen portada.99fbdd3c.jpg";